if (!customElements.get('ng-family-gallery')) customElements.define('ng-family-gallery', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-family-photo], [data-family-overview]');
      if (button && this.contains(button)) this.select(button);
    }, options);
    this.addEventListener('keydown', event => {
      const buttons = [...this.querySelectorAll('.ng-family-gallery__thumbs button')];
      const index = buttons.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 :
        (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].focus({ preventScroll: true });
      buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      this.select(buttons[next]);
    }, options);
    ngFamilyPurchaseLinks();
  }
  disconnectedCallback() { this.abort?.abort(); }
  select(button) {
    const image = this.querySelector('[data-family-main]');
    const overview = button.hasAttribute('data-family-overview');
    this.querySelector('[data-family-bundle]').hidden = !overview;
    image.hidden = overview;
    if (!overview) {
      image.src = button.dataset.familyPhoto;
      image.alt = button.dataset.familyLabel;
    }
    this.querySelector('[data-family-caption]').textContent = overview ?
      'Bundle overview: four personal alarms and two door alarms' :
      button.dataset.familyLabel + ' product photograph';
    this.querySelectorAll('.ng-family-gallery__thumbs button').forEach(item =>
      item.setAttribute('aria-pressed', String(item === button)));
  }
});

// Link to Horizon's real section-specific form and retain native variant behavior.
function ngFamilyPurchaseLinks() {
  const summary = document.querySelector('.ng-family-summary');
  const details = summary?.closest('.product-details');
  const target = details?.querySelector('[id^="BuyButtons-ProductForm-"]');
  if (!target) return;
  document.querySelectorAll('.ng-family-summary__jump,.ng-pdp__cta').forEach(link => {
    link.href = '#' + target.getAttribute('id');
    if (link.dataset.familyLinked) return;
    link.dataset.familyLinked = 'true';
    link.addEventListener('click', event => {
      const currentDetails = document.querySelector('.ng-family-summary')?.closest('.product-details');
      const picker = currentDetails?.querySelector('variant-picker');
      const focusTarget = picker?.querySelector('input:checked:not(:disabled),select:not(:disabled)') || picker ||
        currentDetails?.querySelector('[id^="BuyButtons-ProductForm-"]');
      if (!focusTarget) return;
      event.preventDefault();
      (picker || focusTarget).scrollIntoView({ block: 'center', behavior: 'instant' });
      if (!focusTarget.matches('input,select,button,a')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
    });
  });
  window.ngFamilyPurchaseObserver?.disconnect();
  window.ngFamilyPurchaseObserver = new IntersectionObserver(entries => {
    document.body.classList.toggle('ng-family-purchase-visible', entries[0].isIntersecting);
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
  window.ngFamilyPurchaseObserver.observe(target);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ngFamilyPurchaseLinks);
else ngFamilyPurchaseLinks();
document.addEventListener('shopify:section:load', ngFamilyPurchaseLinks);
document.addEventListener('shopify:product:select', event => {
  event.promise?.then(() => requestAnimationFrame(ngFamilyPurchaseLinks)).catch(() => {});
});

